module.exports = __webpack_public_path__ + "img/ba353ca4b75dd27160fc7eed308a4e2.666b2a94.png";